module.exports = __webpack_public_path__ + "img/CA.811c7617.svg";